import axios from 'axios'

/**
 * @desc Fetch User Email Preferences
 *
 */
export const fetchEmailPreferences = () =>
  axios.get('/authenticated/email-preferences').then((res) => res.data)

/**
 * @desc Updates User Email Preferences
 */
export const updateEmailPreferences = (request) =>
  axios.put('/authenticated/email-preferences', request).then((res) => res.data)
